import { Provider as AssetsProvider } from "@queenjs/assets/queenjs/adapter/vue";
import zh_cn from "ant-design-vue/es/locale/zh_CN";
import { queenApi } from "queenjs";
import { Provider } from "queenjs/adapter/vue";
import { createApp, defineComponent } from "vue";
import { Router } from "vue-router";
import "./styles";

let setModuleHooks: any[] = [];

const App = defineComponent(() => {
  setModuleHooks.forEach((hook) => hook());
  setModuleHooks = [];
  return () => (
    <Provider locale={zh_cn}>
      <AssetsProvider />
      <router-view></router-view>
    </Provider>
  );
});

export function startApp(
  router: Router,
  hooks: any[] = [],
  callback?: (app: ReturnType<typeof createApp>) => void
) {
  setModuleHooks = hooks;
  queenApi.router = router;
  const app = createApp(App);
  callback?.(app);
  app.use(router).mount("#app");
}
